import { gql } from '@apollo/client';

export const getPhoneNumbers = gql`
    query getPhoneNumbers($countryCode: String!, $limit: Int!, $cityCode: Int = null, $numberType: String!) {
        getPhoneNumbers(countryCode: $countryCode, limit: $limit, cityCode: $cityCode, numberType: $numberType) {
            ... on PhoneNumbersType {
                success
                error
                phoneNumbers {
                    phoneNumber
                }
            }
        }
    }
`;
